var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32251 8.90484C1.32251 8.90484 3.32121 4.24121 7.98484 4.24121C12.6485 4.24121 14.6472 8.90484 14.6472 8.90484C14.6472 8.90484 12.6485 13.5685 7.98484 13.5685C3.32121 13.5685 1.32251 8.90484 1.32251 8.90484Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98478 10.9035C9.08864 10.9035 9.98348 10.0087 9.98348 8.90483C9.98348 7.80098 9.08864 6.90613 7.98478 6.90613C6.88093 6.90613 5.98608 7.80098 5.98608 8.90483C5.98608 10.0087 6.88093 10.9035 7.98478 10.9035Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.1,
    strokeWidth: 1.3325,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.dda5d96fec34905643537753dfee1fb3.svg";
export { ForwardRef as ReactComponent };